import Vue from 'vue'
import FlowAdaptive from 'flow-adaptive-vue'

Vue.use(FlowAdaptive, {
  fontRatio: 1440 / 10,
  maxWidth: 1440,
  minWidth: 650,
  breakPoints: [
    {
      minWidth: 897,
      maxWidth: 1023,
      fontRatio: 1440 / 10,
    },
    {
      minWidth: 769,
      maxWidth: 896,
      fontRatio: 896 / 10,
    },
    {
      maxWidth: 768,
      fontRatio: 768 / 10,
    },
  ],
})
